import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import PpwrDashboardService from 'src/modules/3rd-party-management/apis/admin/PpwrDashboardService';

export const PPWR_PACKAGING_RISK_MATRIX_QUERY_KEY = '3rd-party-management-fetch-ppwr-packaging-risk-matrix';

const usePackagingRiskMatrix = ({
    t,
}) => {
    return useQuery({
        queryKey: [PPWR_PACKAGING_RISK_MATRIX_QUERY_KEY],
        queryFn: async () => {
            const service = PpwrDashboardService.getInstance();

            return await service.fetchPackagingRiskMatrix();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching packaging risk matrix data.'), {
                type: 'error',
            });
        },
    });
};

export default usePackagingRiskMatrix;
